import { LeadingAgentsCarousel, LeadingAgentsCarouselProps, EventProps, AgentDetails } from './leading-agents-carousel';
import withEvents from 'analytics/withEvents';


const LeadingAgentsCarouselWithEvents = withEvents<LeadingAgentsCarouselProps>(sendEvent => ({
  onCarouselScroll(props: EventProps) {
    sendEvent('agent_carousel_scroll', 'agent', {
      agent_details: {},
      office_details: {},
      event: {
        carousel_type: 'leading_agent',
        direction: props.direction,
        action: props.action,
      },
    });
  },
  onCardClick(agentDetails: AgentDetails) {
    sendEvent('agent_leader_card_click', 'agent', {
      agent_details: agentDetails,
      office_details: {},
      event: {
        agent_details: agentDetails,
      },
    });
  },
  onCardExposeEvent(agentDetails: AgentDetails) {
    sendEvent('agent_leader_card_expose', 'agent', {
      agent_details: agentDetails,
      office_details: {},
      event: {
        agent_details: agentDetails,
      },
    });
  },
}))(LeadingAgentsCarousel);

export default LeadingAgentsCarouselWithEvents;
